export default __webpack_public_path__ + "static/pay-gap-hero-40af4f0e1a3cf81337906c9c111c0b8c.jpg";